module.exports = __webpack_public_path__ + "img/folder.6f46a4a5.svg";